<template>
    <SimpleTable formclass="Charger/form" endpoint="chargers" :aditionalColumns="headers">
        <template>
            <h1>Carregadores</h1>
            <v-divider class="mb-4" />
        </template>
    </SimpleTable>
</template>

<script>
import SimpleTable from "@/components/core/SimpleTable";
export default {
    components: {
        SimpleTable,
    },
    data() {
        return {
            headers: [
                { text: this.$t("Habilitado"), value: "enable", align: "right", sortable: false },
                { text: this.$t("Código"), value: "name", align: "right", sortable: true },
            ],
        };
    },
};
</script>